// 表单数据
export const formData = {
    name: '',
    width: '',
    height: '',
    type: ''
}

// 表单验证规则
export const formRules = {
    name: [{ required: true, message: "标题不能为空", trigger: "blur" }],
    width: [{ required: true, message: "宽度不能为空", trigger: "blur" }],
    height: [{ required: true, message: "高度不能为空", trigger: "blur" }],
    type: [{ required: true, message: "类型不能为空", trigger: "blur" }]
}